import { __assign } from "tslib";
import React from 'react';
import { withBemMod } from '@bem-react/core';
import { cnTabsMenu } from '../TabsMenu';
import './TabsMenu_layout_horiz.css';
/**
 * Модификатор, отвечающий за расположение вкладок.
 * @param {ITabsMenuLayoutHorizProps} props
 */
export var withLayoutHoriz = withBemMod(cnTabsMenu(), { layout: 'horiz' }, function (TabsMenu) { return function (props) { return React.createElement(TabsMenu, __assign({}, props, { orientation: "horizontal" })); }; });
